<template>
<div class="bg-white overflow-hidden shadow rounded-lg">
  <div class="border-b border-gray-200 px-4 py-4 sm:px-6">
    <h3 class="text-regular leading-4 font-medium text-gray-900">
      {{selecteddevice.name || ''}}
    </h3>
  </div>
  <div class="px-4 py-4 sm:p-6">
    <apexchart
      type="bar"
      height="210"
      width="100%"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts
  },
  props: {
    selecteddevice: {
      required: true,
      type: Object
    },
    start: String,
    end: String
  },
  mounted() {
    this.waitForCounts()
  },
  computed: {
    counts() {
      return this.$store.getters.counts
    }
  },
  watch: {
    selecteddevice(newValue, oldValue) {
      if(newValue !== oldValue){
        this.waitForCounts()
        //this.$forceUpdate() //no es necesario? 0:
      }
    }
  },
  methods: {
    async waitForCounts() {
      if (this.selecteddevice.devid) {
        await this.$store.dispatch('getCounts', { 'devid': this.selecteddevice.devid, 'freq': 'hour', 'start': this.start, 'end': this.end })
        const response = await this.$http.get(`assigns?devid=${this.selecteddevice.devid}&start=${this.start}&end=${this.end}`)
        this.assigns = response.data.assigns.map( item => (
          {
            start: new Date(item.start + 'Z').getTime(),
            end: new Date(item.end + 'Z').getTime(),
            vprem: item.vpremiada
          }
        ))
        let countsHour = this.counts.hour.map( h => {
            let vprem = ''
            for (const item of this.assigns){
              if (h.x > item.start && h.x < item.end){
                vprem = item.vprem
              }
            }
            return {
              x: h.x,
              y: h.y,
              vprem: vprem
            }
          }
        )
        this.series = [{ data: countsHour }]
      }
    }
  },
  data() {
    return {
      assigns: [],
      series: [
        {
          name: "Velocidad",
          data: []
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "70%"
          }
        },
        colors: [function({ value, dataPointIndex, w}) {
          if (w.globals.initialSeries[0].data.length === 0){
            return ""
          }
          if (value >= w.globals.initialSeries[0].data[dataPointIndex].vprem) {
            return "#68D138"
          }
          else {
            return "#D93D39"
          }
        }],
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false
          }
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"]
        },
        fill: {
          opacity: 1,
        },
      }
    };
  }
};
</script>
